import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import Layout from '../components/common/Layout'

// Admin Pages
import AdminOverview from '../components/admin/AdminOverview'
import ClientManager from '../components/admin/ClientManager'
import SimpleClientManager from '../components/admin/SimpleClientManager'
import SiteManager from '../components/admin/SiteManager'
import CodeEditor from '../components/admin/CodeEditor'
import MediaLibrary from '../components/admin/MediaLibrary'
import RequestManager from '../components/admin/RequestManager'
import AnalyticsDashboard from '../components/admin/AnalyticsDashboard'
import BillingDashboard from '../components/admin/BillingDashboard'
import UserManager from '../components/admin/UserManager'
import AdminSettings from '../components/admin/AdminSettings'
import SiteSettings from '../components/admin/SiteSettings'
import NewClient from '../components/admin/NewClient'
import ClientDetail from '../components/admin/ClientDetail'
import EditClient from '../components/admin/EditClient'
import EditLogsDashboard from '../components/admin/EditLogsDashboard'
import DomainDashboard from '../components/admin/DomainDashboard'
import SupportManagement from '../components/admin/SupportManagement'
import AdminHelp from '../components/admin/AdminHelp'
import AdminHelpPreview from '../components/admin/AdminHelpPreview'
import AdminBackupDashboard from '../components/admin/AdminBackupDashboard'
import NotificationsPage from '../components/admin/NotificationsPage'
import AdminTools from '../components/admin/AdminTools'
import NewEditor from '../components/admin/NewEditor'
import SitePreview from '../components/client/SitePreview'

// Layout wrapper component that renders the Layout and Outlet
const AdminLayout = () => {
  return <Layout userRole="admin" />
}

const AdminDashboard = () => {
  return (
    <Routes>
      {/* Full-screen client preview — rendered outside the admin layout (no admin sidebar) */}
      <Route path="help/preview" element={<AdminHelpPreview />} />
      <Route path="/*" element={<AdminLayout />}>
        <Route index element={<AdminOverview />} />
        <Route path="clients" element={<ClientManager />} />
        <Route path="clients/new" element={<NewClient />} />
        <Route path="clients/:clientId" element={<ClientDetail />} />
        <Route path="clients/:clientId/edit" element={<EditClient />} />
        <Route path="sites" element={<SiteManager />} />
        <Route path="sites/new" element={<SiteManager openNew />} />
        <Route path="sites/:siteId/preview" element={<SitePreview />} />
        <Route path="sites/:id/settings" element={<SiteSettings />} />
        <Route path="editor" element={<CodeEditor />} />
        <Route path="neweditor" element={<NewEditor />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="requests" element={<RequestManager />} />
        <Route path="analytics" element={<AnalyticsDashboard />} />
        <Route path="billing" element={<BillingDashboard />} />
        <Route path="users" element={<UserManager />} />
        <Route path="edit-logs" element={<EditLogsDashboard />} />
        <Route path="domains" element={<DomainDashboard />} />
        <Route path="support" element={<SupportManagement />} />
        <Route path="help" element={<AdminHelp />} />
        <Route path="backups" element={<AdminBackupDashboard />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="tools" element={<AdminTools />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  )
}

export default AdminDashboard